import Suffix from "./Suffix";

export default function PlatinumPlusExclusiveSuffix(container: Element) {
  if (!container) return;
  const ppePurchase = container.querySelector<HTMLElement>(
    ".member-exclusive__banner"
  );
  if (!ppePurchase) return;
  const ATCButtonContainer = container
    .querySelector<HTMLElement>(".btn-cart")
    ?.closest("div");
  if (!ATCButtonContainer) return;

  const handleItemNumberChange = (ev: Event) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const event = ev as CustomEvent;
    const itemNumber = event.detail.toString();
    const suffix = Suffix.priceLookup(itemNumber);
    const priceBox = document.querySelector<HTMLElement>("#priceBox");

    ATCButtonContainer.hidden =
      (suffix.isPlatinumPlusExclusive && !suffix.customerIsPlatinumOrPlus) ||
      suffix.unavailable === "1";
    ppePurchase.hidden = !suffix.isPlatinumPlusExclusive;
    if (priceBox) {
      if (suffix.isPlatinumPlusExclusive) {
        priceBox.classList.add("member-exclusive");
      } else {
        priceBox.classList.remove("member-exclusive");
      }
    }
  };

  container.addEventListener("ItemNumber.change", handleItemNumberChange);
}
